//------------------------------------------------------ externos
import { useEffect, useState } from "react";
//------------------------------------------------------ elementos
import FormContent from "../funcionales/FormContent";
import MarcoModal from "../funcionales/MarcoModal";
import FormHeader from "../funcionales/FormHeader";
import TextButton from "../buttons/TextButton";
import Loading from "../../routes/Loading";
//------------------------------------------------------ funciones
import { cargarSelects } from "../../functions/dataFunctions";
import { submitMovimientoAsignacion } from "./data/Submits";
import { eventos } from "./data/FormContent";
//import { refreshCache } from "../../services/cache";
import { useAuth } from "../../auth/AuthContext";
//------------------------------------------------------ estilos
import "./css/Forms.css";

const FormAsignacion = ({ elemento = null, onGuardar, onClose }) => {
  const modoEdicion = !!elemento;
  const titulo = modoEdicion ? "Editar" : "Asignar";
  const subtitulo = "Articulo / Herramienta";
  const campos = eventos["asignaciones"];
  const { fullUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [listas, setListas] = useState({}); //para los selects, recibe un array tipo {tractores: ..., furgones: ...}
  const [formData, setFormData] = useState({
    // información específica
    id: elemento?.id || "",
    persona: elemento?.persona || "",
    //articulo: elemento?.articulo || "",
    //cantidad: elemento?.cantidad || "",
    ingresos: elemento?.ingresos || [], // reemplaza articulo y cantidad para asignar muchos
    area: elemento?.area || "administracion",
    // detalles y comentarios
    detalle: elemento?.detalle || "",
  });

  useEffect(() => {
    const cargarDatos = async () => {
      const data = await cargarSelects(); // trae TODOS los listados, ver si se puede mejorar desp
      setListas(data);
      setLoading(false);
    };

    cargarDatos();
  }, []);

  const handleSubmit = async () => {
    await submitMovimientoAsignacion(
      elemento?.id,
      formData,
      campos,
      setLoading,
      onGuardar,
      onClose,
      fullUser,
    );
  };

  return (
    <MarcoModal onClose={onClose}>
      {loading ? (
        <Loading />
      ) : (
        <div className="form-content">
          <FormHeader title={titulo} subTitle={subtitulo} onClose={onClose} />

          <FormContent
            elemento={elemento}
            campos={campos}
            opciones={listas}
            data={formData}
            listado={listas["stock"]}
            setData={setFormData}
          />

          <div className="form-buttons">
            <TextButton
              text={"Guardar"}
              type={"button"}
              onClick={handleSubmit}
            />
          </div>
        </div>
      )}
    </MarcoModal>
  );
};

export default FormAsignacion;
